import React, { useMemo, useCallback, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import OrderTable from "../../components/OrderManagement/OrderTable";
import { useFetchOrderDetails } from "../../hooks/useFetchOrderDetails";
import { useOrderCancellationActions } from "hooks/useOrderCancellationActions";
import ErrorSnackbar from "../../widgets/Snackbar/ErrorSnackbar";
import SuccessSnackbar from "../../widgets/Snackbar/SuccessSnackbar";
import {
  ORDER_CANCELLATION_REQUESTED_STATUS_ID,
  ORDER_CANCELLED_STATUS_ID,
} from "constants/constants";

const ACTION_LABEL = {
  accept: "accepted",
  reject: "rejected",
};

const OrderCancellation = () => {
  const { studentId } = useParams();
  const {
    data,
    isLoading,
    error: fetchError,
    refetch,
  } = useFetchOrderDetails(studentId);

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  
  useEffect(() => {
    if (fetchError) {
      setErrorMsg(`Failed to load order details. ${fetchError.message}`);
    }
  }, [fetchError]);

  const ordersData = data?.data?.order_details || [];

  const filteredOrders = useMemo(
    () =>
      ordersData.filter(
        (order) =>
          order.status?.id === ORDER_CANCELLATION_REQUESTED_STATUS_ID ||
          order.status?.id === ORDER_CANCELLED_STATUS_ID,
      ),
    [ordersData],
  );

  const handleSuccess = useCallback(
    (action) => {
      setSuccessMsg(`Order cancellation ${ACTION_LABEL[action]} successfully.`);
      refetch();
    },
    [refetch],
  );

  const handleError = useCallback((action, order, message) => {
    setErrorMsg(`Failed to ${action} cancellation request. ${message}`);
  }, []);

  const { acceptCancellation, rejectCancellation, isOrderLoading } =
    useOrderCancellationActions({
      onSuccess: handleSuccess,
      onError: handleError,
    });

  return (
    <>
      <OrderTable
        title="Order Cancellation"
        orders={filteredOrders}
        isLoading={isLoading}
        fetchError={fetchError}
        actionableStatusIds={[ORDER_CANCELLATION_REQUESTED_STATUS_ID]}
        isOrderLoading={isOrderLoading}
        onAccept={acceptCancellation}
        onReject={rejectCancellation}
      />

      <ErrorSnackbar
        open={!!errorMsg}
        message={errorMsg}
        onClose={() => setErrorMsg("")}
      />

      <SuccessSnackbar
        open={!!successMsg}
        message={successMsg}
        onClose={() => setSuccessMsg("")}
      />
    </>
  );
};

export default OrderCancellation;
